import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { patientData } from '../models/patientData';
import { Patient } from '../models/pateint';
import { ApplicationFilter } from '../models/application-filter';
import { API_ROUTES, BASE_URL } from '../../core/constants/api.const';
import { ApiRoutesModel } from '../../core/models/apiRoutesModel';
import { PatientDTO } from '../models/patientDTO';
import { LazyLoadEvent } from 'primeng/api';


@Injectable({
  providedIn: 'root',
})
export class PatientsApplicationsService {
  constructor(
    private http: HttpClient,
    @Inject(BASE_URL) private readonly baseURL: string,
    @Inject(API_ROUTES) private readonly apiRoutes: ApiRoutesModel) {
  }

  getData(filter: LazyLoadEvent): Observable<PatientDTO[]> {
    let url = `${this.baseURL}/${this.apiRoutes.applications.paginatedData}`;
    var filterStr = this.buildString(filter);
    url += `?${filterStr}`;
    return this.http.get<PatientDTO[]>(url)
  }

  buildString(filter: LazyLoadEvent): string {

    // Extract properties from filter
    var { first, rows, sortField, sortOrder, filters } = filter;

    var page: number = 0;

    // Check if required properties exist
    if (first && rows) {
      // Calculate page number
      page = first / rows;
    }

    var sortDirection = 'asc';

    // Determine sort field
    if (sortOrder) {
      sortDirection = sortOrder > 0 ? 'desc' : 'asc';
    }

    if (sortField == null) {
      sortField = 'id';
    }

    var url = `page=${page}&size=${rows}&sortBy=${sortField}&sortDirection=${sortDirection}`;

   
    var filterURL = ''
    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        if (filters[key]) {
          const value = filters[key].value;
          if (value !== null && value !== '') {
            // Append to query parameters
            console.log('encodeURIComponent(value)', encodeURIComponent(value))
            filterURL += `&${key}=${encodeURIComponent(value)}`;
          }
        }
      }
    }

    
    url += filterURL;
    return url;
  }

  getPatientById(id: string): Observable<Patient> {
    let url = `${this.baseURL}/${this.apiRoutes.applications.patientData}/${id}`;
    return this.http.get<Patient>(url)
  }

  setStatus(applicationId: number, mrn: number | string, applicationStatus: string, appointmentDate: string | Date | null): Observable<any> {
    let url = `${this.baseURL}/${this.apiRoutes.applications.mrnUpdate}/${applicationId}/${mrn}/${applicationStatus}/${appointmentDate}/userNotes`;

    const options = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
    };
    return this.http.patch<any>(url, options)
  }

  getFile(nationalID: string, applicationID: number, fileName: string, type: string) {
    let url = `${this.baseURL}/${this.apiRoutes.applications.documents}?national-id=${nationalID}&application_id=${applicationID}&file-name=${fileName}.${type}`;
    return this.http.get(url, {responseType: 'blob'});
  }

  filterData(filter: ApplicationFilter): Observable<patientData[]> {
    let queryParams = Object.keys(filter)
      .filter(param => filter[param as keyof ApplicationFilter])
      .map(param => `${param}=${filter[param as keyof ApplicationFilter]}`)
      .join('&');

    let url = `${this.baseURL}/${this.apiRoutes.applications.patientData}?${queryParams}`;
    return this.http.get<patientData[]>(url)
  }

  setName(patient: Patient): Observable<any> {
    let url = `${this.baseURL}/${this.apiRoutes.applications.setName}/${patient.id}/${patient.name}`;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.patch<any>(url, options)
  }

  public showProgressBar = false;

  show(): void {
    this.showProgressBar = true;
  }

  hide(): void {
    this.showProgressBar = false;
  }
}
